module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component.css
// module id = ./src/app/court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component.css
// module chunks = main